export const LIST_LOGS_SUCCESS = 'LIST_LOGS_SUCCESS';
export const LIST_LOGS_FAILURE = 'LIST_LOGS_FAILURE';
